import { render, staticRenderFns } from "./SystemNotificationsTable.vue?vue&type=template&id=a8d08f90&"
import script from "./SystemNotificationsTable.vue?vue&type=script&lang=js&"
export * from "./SystemNotificationsTable.vue?vue&type=script&lang=js&"
import style0 from "./SystemNotificationsTable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports